import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class QuotasProductModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Event][getAll] organizationId is mandatory`);
        }
        return `/ticket/organizations/${organizationId}/quota_products`;
    }
}
